const brandLogos = [
  {
    name: 'Partenaire 1',
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/e4fb7c41-6f12-46ba-b744-e823712fec53_Capture-dcran-2026-03-22-113521.png?v=02ef7670faf09383525bc2387dec8289',
  },
  {
    name: 'Partenaire 2',
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/51f386a6-9136-40e2-9c32-debfd994d34b_WhatsApp-Image-2026-03-21-at-19.06.18.jpeg?v=0f489410894b5d71abc6b6228129c20d',
  },
  {
    name: 'Partenaire 3',
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/ab38f95a-05a9-4d23-ad20-8ea839da4c0d_WhatsApp-Image-2026-03-21-at-19.06.43.jpeg?v=c590d844beb4560adb7f43488d920f15',
  },
  {
    name: 'Partenaire 4',
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/1586e934-0a9a-4c7c-b4b9-b86406c1dbbf_WhatsApp-Image-2026-03-21-at-19.07.26.jpeg?v=a8297deb218a81d5c367649d712362d5',
  },
  {
    name: 'Partenaire 5',
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/029cdf02-be53-47d0-821c-c31a8454c76f_WhatsApp-Image-2026-03-21-at-19.07.48.jpeg?v=2d600442d5df9ff7a12f7e10aa1f9571',
  },
  {
    name: 'Partenaire 6',
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/1a8a8fb8-6be6-4fa5-be0f-8ae647657b76_Capture-dcran-2026-03-22-151114.png?v=96c5da1b6c2595dcb073ed21af4317b6',
  },
];

const BrandsSection = () => (
  <section className="w-full py-16 bg-white border-y border-[#e8f2fa]">
    <div className="max-w-5xl mx-auto px-6">
      {/* Header */}
      <div className="text-center mb-10">
        <div className="flex items-center justify-center gap-3 mb-3">
          <div className="h-px w-12 bg-[#1a8abf]" />
          <span className="text-[#1a8abf] text-xs font-bold uppercase tracking-widest">Nos Partenaires</span>
          <div className="h-px w-12 bg-[#1a8abf]" />
        </div>
        <h2 className="text-2xl lg:text-3xl font-black text-[#002060]">
          Marques que nous installons &amp; maintenons
        </h2>
        <p className="text-[#4a6272] text-sm mt-3 max-w-xl mx-auto">
          Polar Clim travaille avec les meilleures marques du marché pour vous garantir qualité, fiabilité et performance sur le long terme.
        </p>
      </div>

      {/* Hitachi CTA card — EN PREMIER */}
      <div className="mb-8 w-full rounded-2xl overflow-hidden relative"
        style={{
          background: 'linear-gradient(135deg, #002060 0%, #003580 45%, #1a8abf 100%)',
        }}
      >
        {/* Decorative circles */}
        <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full opacity-10" style={{ background: 'white' }} />
        <div className="absolute -bottom-10 -left-10 w-36 h-36 rounded-full opacity-10" style={{ background: 'white' }} />

        <div className="relative flex flex-col md:flex-row items-center justify-between px-6 md:px-12 py-8 gap-6 text-center md:text-left">
          {/* Left: Hitachi logo + title */}
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <span className="font-black text-3xl md:text-4xl tracking-widest leading-none" style={{ color: '#CC0000', textShadow: '0 0 20px rgba(204,0,0,0.4)', letterSpacing: '0.12em' }}>
              HITACHI
            </span>
            <div className="hidden md:block h-10 w-px bg-white/20" />
            <div>
              <p className="text-white font-black text-lg leading-tight">Installateur agréé</p>
              <p className="text-white/70 text-sm">en région Sud</p>
            </div>
          </div>

          {/* Center: Badges */}
          <div className="flex flex-wrap justify-center md:justify-start gap-2 items-center">
            {['✓ Pièces d\'origine', '✓ Garantie constructeur', '✓ Stock disponible'].map((item) => (
              <span
                key={item}
                className="text-xs font-semibold text-white/90 px-3 py-1.5 rounded-full whitespace-nowrap"
                style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)' }}
              >
                {item}
              </span>
            ))}
          </div>

          {/* Right: CTA button */}
          <button
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white font-black text-sm px-8 py-3.5 rounded-full cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity"
            style={{ color: '#002060' }}
          >
            Demander un Devis
          </button>
        </div>
      </div>

      {/* Logos grid — autres marques */}
      <div className="flex flex-wrap justify-center items-center gap-6">
        {brandLogos.map((brand) => (
          <div
            key={brand.name}
            className="flex items-center justify-center rounded-xl border border-[#e0eef8] hover:border-[#1a8abf] transition-all duration-300 bg-white"
            style={{ width: 170, height: 90 }}
          >
            <img
              src={brand.img}
              alt={brand.name}
              className="max-h-16 max-w-[140px] w-auto h-auto object-contain"
            />
          </div>
        ))}
      </div>

      {/* Bottom note */}
      <p className="text-center text-xs text-[#8aa0b0] mt-10">
        Installateur agréé et certifié par les fabricants — pièces d&apos;origine garanties.
      </p>
    </div>
  </section>
);

export default BrandsSection;
